export default __webpack_public_path__ + "img/dcqHPCXJ.7589a226.svg";